import React from 'react';

const ServiceSchema = ({ 
  name = 'Water Damage Restoration',
  description = 'Emergency water damage restoration services including water extraction, drying, and repairs.',
  url = 'https://www.waterdamagedirect.com',
  imageUrl = 'https://www.waterdamagedirect.com/images/service-restoration.jpg',
  provider = 'Water Damage Direct',
  areaServed = 'United States'
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": name,
    "description": description,
    "provider": {
      "@type": "Organization",
      "name": provider
    },
    "url": url,
    "image": imageUrl,
    "serviceType": name,
    "areaServed": {
      "@type": "Country",
      "name": areaServed
    },
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default ServiceSchema;